import { render } from "./NuovoFornitore.vue?vue&type=template&id=04269da1&ts=true"
import script from "./NuovoFornitore.vue?vue&type=script&lang=ts"
export * from "./NuovoFornitore.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__